import { QUERY_TYPES } from "./QueryConfigs";

export const FORM_CATEGORIES = [
  "General",
  "Feedback",
  "Support",
  "Sales",
  "Marketing",
  "HR",
  "Booking",
  "Events",
  "Education",
  "Healthcare",
  "Real Estate",
  "Travel",
  "E-commerce",
  "Finance",
  "Legal",
  "Other",
];

// Optional: Mapper function to link Categories -> Styles
const CATEGORY_MAP = {
  General: "CONVERSATION",
  Feedback: "FEEDBACK",
  Support: "QUERY",
  Sales: "LEAD",
  Marketing: "LEAD",
  HR: "CONVERSATION",
  Booking: "CONVERSATION",
  Events: "CONVERSATION",
  Education: "CONVERSATION",
  Healthcare: "QUERY",
  "Real Estate": "LEAD",
  Travel: "CONVERSATION",
  "E-commerce": "LEAD",
  Finance: "LEAD",
  Legal: "QUERY",
  Other: "CUSTOM",
};

export const getQueryStyle = (category) => {
  if (!category) return QUERY_TYPES.CUSTOM;

  // 1. Try exact match from the map
  if (CATEGORY_MAP[category]) {
    return QUERY_TYPES[CATEGORY_MAP[category]];
  }

  // 2. Try case-insensitive match (Fixes filtering issues)
  const lowerCat = category.toLowerCase();
  const foundKey = Object.keys(CATEGORY_MAP).find(
    (key) => key.toLowerCase() === lowerCat
  );

  if (foundKey) {
    return QUERY_TYPES[CATEGORY_MAP[foundKey]];
  }

  // 3. Fallback
  return QUERY_TYPES.CUSTOM;
};
